<!-- See: https://github.com/primefaces/primeng/issues/16493 -->
<p-autoComplete [ngModel]="selectedBudgetLineCodes" (ngModelChange)="onBudgetLinesChange($event)"
  name="budgetLines" [disabled]="mode !== DetailMode.EDITION"
  class="budgetlines-autocomplete acted-highlight-req metadata-field" [required]="required"
  [suggestions]="allBudgetLineCodes" (completeMethod)="getBudgetLineSuggestions($event)"
  [multiple]="true" [forceSelection]="true"
  [dropdown]="false" dropdownMode="current" i18n-placeholder="@@common-none" placeholder="(none)" appendTo="body" [tabindex]="tabindex">
</p-autoComplete>

@if (mode === 'edition' && recommended && isEmpty(this.budgetLines)) {
  <app-required-field-text/>
}
